import React from 'react';
import Button from 'react-bootstrap/Button';
import SunIcon from '../assets/sun_icon.svg';
import './Events.css';

const Events = () => {
  return (
    <section className="events-section">
      <div className="container">
        <h2 className="events-title" id="events">UPCOMING EVENTS</h2>
        
        <div className="events-container">

          <div className="event-separator">
            <img src={SunIcon} alt="Sun separator" className="sun-icon" />
          </div>

          <div className="event-card">
            <div className="event-content">
              <h3 className="event-name">YOUTH ART SHOW</h3>
              <p className="event-date">Saturday, March 21st</p>
              <div className="event-location">
                <p className="venue-city">Camp Verde, AZ</p>
              </div>
            </div>
            <div className="event-description">
              <p>Come join us at the Camp Verde Gym to support our communities kids and teenagers at our youth art show. If you'd like to submit your work, please contact us!</p>
              <div className="button-wrapper">
                <Button className="contact-btn">CONTACT US</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Events;